import { DEPLOYMENT_STATES } from '@/constants/device';

export const INVENTORY_PAGE_SIZE = 10;
export const INVENTORY_UNPAGED_LIMIT = 1000;

const BASE_QUERY_PARAMS = {
  filterkey: 'category',
  filtervalue: 'DEVICE-PRIMARY',
  sortby: 'deviceid',
  orderby: 'asc',
};

// Each group is single-select; the accounts group is hidden from Staff users.
export const getInventoryFilterGroups = (isStaff) => [
  { key: 'connected', children: [{ key: 'online' }, { key: 'offline' }] },
  ...(isStaff
    ? []
    : [
        {
          key: 'accounts',
          children: [
            { key: 'demoAccount' },
            { key: 'deployedWithClient' },
            { key: 'assigned' },
            { key: 'readyToAssign' },
            { key: 'notActivated' },
            { key: 'notReady' },
          ],
        },
      ]),
];

const ACCOUNT_SERVER_FILTERS = {
  // When the user is assigned to the device
  assigned: { keys: 'useruuid', values: 'not empty' },
  // Provisioned, no user, and cleared of old user data
  readyToAssign: {
    keys: '-useruuid,provisioningstatus,-operationalstatus',
    values: 'not empty,Provisioned,TO_DO_FACTORYRESET',
  },
  // Not provisioned and no user
  notActivated: { keys: '-provisioningstatus,-useruuid', values: 'Provisioned,not empty' },
  // Provisioned, no user, pending factory reset
  notReady: {
    keys: '-useruuid,provisioningstatus,operationalstatus',
    values: 'not empty,Provisioned,TO_DO_FACTORYRESET',
  },
};

// Demo/Client have no server filter (Client includes devices without a deployment state), so
// they travel as `deployment` and are applied by useGetInventoryDevices before paging.
const DEPLOYMENT_FILTERS = ['demoAccount', 'deployedWithClient'];

export const matchesDeploymentFilter = (device, deployment) => {
  if (!deployment) return true;
  const state = device?.deployment_state ?? null;
  if (deployment === 'demoAccount') return state === DEPLOYMENT_STATES.NOT_DEPLOYED;
  return state === DEPLOYMENT_STATES.DEPLOYED || state === null;
};

export const buildInventoryQueryParams = (filters = [], search = '') => {
  const params = { ...BASE_QUERY_PARAMS };
  const addServerFilter = (keys, values) => {
    params.filterkey += `,${keys}`;
    params.filtervalue += `,${values}`;
  };

  [...filters]
    .sort((a, b) => a.groupKey.localeCompare(b.groupKey))
    .forEach(({ groupKey, itemKey }) => {
      if (groupKey === 'connected') {
        addServerFilter('deviceconnectstatus', itemKey === 'online' ? 'CONNECTED' : 'DISCONNECTED');
      } else if (DEPLOYMENT_FILTERS.includes(itemKey)) {
        params.deployment = itemKey;
      } else if (ACCOUNT_SERVER_FILTERS[itemKey]) {
        const { keys, values } = ACCOUNT_SERVER_FILTERS[itemKey];
        addServerFilter(keys, values);
      }
    });

  if (search) {
    // Matched against both device ID and account name by useGetInventoryDevices.
    params.search = search.toLowerCase();
  }
  return params;
};
